import { FC } from "react";
import { Box, BoxProps } from "shared/components/Spor";

type CircleProps = BoxProps & {
  size?: string;
};

export const Circle: FC<CircleProps> = ({ size, height, width, ...props }) => (
  <Box
    {...props}
    height={size ?? height}
    width={size ?? width}
    borderRadius="100%"
  />
);
